export type RenditionSize = 'avatar' | 'tiny' | 'small' | 'medium' | 'large' | 'xlarge' | 'full';

export const addRendition = ({ url, renditionSize, isProduct }: { url: string; renditionSize?: RenditionSize; isProduct?: boolean }) => {
  if (url.length) {
    try {
      const photoRequestUrl = new URL(url);
      if (renditionSize) {
        photoRequestUrl.searchParams.append('rendition', renditionSize);
      }
      if (isProduct) {
        photoRequestUrl.searchParams.append('product', 'true');
      }
      return photoRequestUrl.toString();
    } catch (err) {
      console.error(err);
    }
  }
  return url;
};
